import loadable from '@loadable/component';
import moment from 'moment-timezone';
import { Component } from 'react';
import Empty from './Empty';

const dynamicImport = ({ tenant, component, fallback = Empty }) => {
  tenant = tenant || process.env.REACT_APP_TENANT;
  component = component.startsWith('/') ? component : '/' + component;
  return loadable(() =>
    import(`../../@${tenant}${component}`).catch(() => fallback)
  );
};

export default dynamicImport;
export class DynamicComponent extends Component {
  constructor(props) {
    super(props);
    moment.locale(props.intl.locale);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dynamicImport/index.js